import subMonths from 'date-fns/subMonths';
import { useState, useCallback } from 'react';

import { Button, SvgIconUrl } from 'common/components';
import CSVButtonComponent from 'common/components/WalletNew/CSVButton/CSVButton.component';

import { useI18n, usePopup } from 'common/hooks';
import svgIcons from 'common/svgIcons';

import { StatementPeriod } from 'views/statement/components/StatementPeriod.component';

import './index.css';

const DEFAULT_PERIOD = {
  key: 'wallet-transactions-export',
  startDate: subMonths(new Date(), 1),
  endDate: new Date(),
};

const WalletTransactionsExportPopup = () => {
  const { translate } = useI18n();
  const { hide } = usePopup();

  const [period, updatePeriod] = useState(DEFAULT_PERIOD);

  const [isProcessing, updateProcessingState] = useState(false);

  const onDateReset = useCallback(() => {
    updatePeriod(DEFAULT_PERIOD);
    return DEFAULT_PERIOD;
  }, []);

  return (
    <div className='wallet-transactions-export-popup' id='wallet-transactions-export-popup'>
      <header className='wallet-transactions-export-popup-header'>
        <div className='wallet-transactions-export-popup-header__icon icon-shadow'>
          <SvgIconUrl
            className='wallet-transactions-export-popup-header__icon-img'
            symbol={svgIcons.exchangeHistoryIcon()}
          />
        </div>
        <p>{translate.toText('wallet:transactions:export:title')}</p>
      </header>

      <main className='wallet-transactions-export-popup-main'>
        <StatementPeriod value={period} onChange={updatePeriod} disabled={isProcessing} onDateReset={onDateReset} />
      </main>

      <footer className='wallet-transactions-export-popup-footer'>
        <Button large stretch outline onClick={hide} disabled={isProcessing}>
          {translate.toText('wallet:transactions:export:cancel')}
        </Button>

        <CSVButtonComponent periodFilter={period} onProcessing={updateProcessingState} onComplete={hide} />
      </footer>
    </div>
  );
};

const WalletTransactionsExportPopupComponent = () => ({
  component: <WalletTransactionsExportPopup />,
  wrapperClassName: 'wallet-transactions-export-popup-wrapper',
  hideCloseIcon: false,
  closeOnClickOutside: false,
});

export default WalletTransactionsExportPopupComponent;
